import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import MarketShowcaseCard from "./MarketShowcaseCard";
import { filterMarketplaceProducts } from "../libs/marketplaceProductVisibility";
import "./ProductCard.css";
import "./MarketProductSection.css";

const MarketProductSection = ({
  title,
  Icon,
  viewAllLink,
  isLoading,
  isError,
  products = [],
  errorMessage,
  emptyMessage,
  onAddToCart,
  limit = 8,
  className = "",
}) => {
  const visibleProducts = filterMarketplaceProducts(products);

  return (
    <div className={`special-product-con ${className}`.trim()}>
      <span className="special-product-con__header">
        <h3 className="special-product-con__title">
          {Icon && <Icon className="special-product-con__title-icon" aria-hidden="true" />}
          {title}
        </h3>
        {viewAllLink && (
          <Link to={viewAllLink} className="special-product-con__view-all">
            VIEW ALL
          </Link>
        )}
      </span>

      {isLoading ? (
        <div className="special-product-card special-product-card--loading">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="market-section-skeleton">
              <Skeleton height={180} borderRadius={12} />
              <Skeleton height={14} width="80%" />
              <Skeleton height={14} width="50%" />
            </div>
          ))}
        </div>
      ) : isError ? (
        <div className="market-section-state market-section-state--error">
          {Icon && <Icon className="market-section-state__icon" aria-hidden="true" />}
          <p>{errorMessage}</p>
        </div>
      ) : visibleProducts.length > 0 ? (
        <div className="special-product-card">
          {visibleProducts.slice(0, limit).map((deal) => (
            <MarketShowcaseCard product={deal} key={deal._id} onAddToCart={onAddToCart} />
          ))}
        </div>
      ) : (
        <div className="market-section-state market-section-state--empty">
          {Icon && <Icon className="market-section-state__icon" aria-hidden="true" />}
          <p>{emptyMessage}</p>
          {viewAllLink && (
            <Link to={viewAllLink} className="market-section-state__link">
              Browse all products
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default MarketProductSection;
